import keyMirror from 'keymirror';

export const lessonDetailsActionTypes = keyMirror({
	GET_SINGLE_LESSON_DETAILS_REQUEST: null,
	GET_SINGLE_LESSON_DETAILS_SUCCESS: null,
	GET_SINGLE_LESSON_DETAILS_ERROR: null,
	GET_SINGLE_LESSON_DETAILS: null,
	GET_SCHEDULE_LESSONS_REQUEST: null,
	GET_SCHEDULE_LESSONS_SUCCESS: null,
	GET_SCHEDULE_LESSONS_ERROR: null,
	DELETE_SCHEDULED_LESSON_REQUEST: null,
	DELETE_SCHEDULED_LESSON_SUCCESS: null,
	DELETE_SCHEDULED_LESSON_ERROR: null,
	SET_LESSON_SIGNED_UP: null,
	GET_LESSON_SIGNED_UP: null,
	CLEAR_LESSON_DETAILS_DATA: null,
});

export const getFaqDetailPage = (t) => [
	{
		title: t('tutoring.lesson_details.faq.section_1.title'),
		description: t('tutoring.lesson_details.faq.section_1.description'),
		link_1: {
			text: t('tutoring.lesson_details.faq.section_1.link_1'),
			videoId: '928755585',
		},
	},
	{
		title: t('tutoring.lesson_details.faq.section_2.title'),
		description: t('tutoring.lesson_details.faq.section_2.description'),
	},
	{
		title: t('tutoring.lesson_details.faq.section_3.title'),
		description: t('tutoring.lesson_details.faq.section_3.description'),
		link_1: {
			text: t('tutoring.lesson_details.faq.section_3.link_1'),
			url: '/lessons',
			linkOutside: false,
		},
	},
	{
		title: t('tutoring.lesson_details.faq.section_4.title'),
		description: t('tutoring.lesson_details.faq.section_4.description'),
	},
];
